import type { ReactNode } from 'react'
import './EmptyState.css'

export interface EmptyStateProps {
  /** Constat précis, qui reprend la saisie : « Aucune famille ne correspond à
   * « hammam kids ». » */
  title: string
  /** Explication ou conséquence — jamais un simple « Aucun résultat ». */
  children?: ReactNode
  /** L'issue proposée (« Effacer la recherche », « Ajouter une prestation »). */
  actionLabel?: string
  onAction?: () => void
}

/**
 * État vide du back-office : il dit ce qui s'est passé, pourquoi, et propose
 * l'issue. La bordure en tirets le distingue d'une carte de contenu — c'est
 * une absence, pas un objet.
 */
export function EmptyState({ title, children, actionLabel, onAction }: EmptyStateProps) {
  return (
    <div className="azoya-empty-state">
      <p className="azoya-empty-state-title">{title}</p>
      {children && <div className="azoya-empty-state-body">{children}</div>}
      {actionLabel && onAction && (
        <button type="button" className="azoya-empty-state-action" onClick={onAction}>
          {actionLabel}
        </button>
      )}
    </div>
  )
}
